import type { FileExportFormat } from "@/composables/options/useFileExportFormatOptions"
import { api } from "@/api"

export type ExportSalesQuery = {
  cashierId?: string
  deviceId?: number
  start?: string
  end?: string
}

export const exportSales = async (
  query: ExportSalesQuery,
  format?: FileExportFormat
) => {
  const response = await api.get<Blob | string>(
    "/reports/sales/export/",
    {
      query: { ...query, format },
    }
  )
  downloadFileFromResponse(response)
}
